import React, { useState } from 'react';
import PropTypes from 'prop-types';
import OpenNew from '../../../../../../assets/open-new/OpenNew';
import { removeOrganisation } from '../../../../duck/actions/clients';
import { useDispatch } from 'react-redux';
import config from '../../../../../../config/index';
import fetchLicenseDetails from '../../../../duck/actions/licenses';
import useUser from '../../../../../../hooks/useUser';
import {
  Popover,
  Card,
  Menu,
  Button,
  Position,
  Text,
  Modal,
  Stack,
  TextLink,
  ButtonGroup,
  Tooltip
} from 'chaser-components';

const Actions = ({ shortCode, isDisabled, isConnected, orgName, refetch }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { emails, bundle: bundleId } = useUser();

  const dispatch = useDispatch();

  async function removeOrg() {
    await removeOrganisation(shortCode, bundleId, emails[0].address);
    refetch();
    dispatch(fetchLicenseDetails(bundleId));
    setModalOpen(false);
  }

  return (
    <>
      <Modal open={modalOpen} toggle={setModalOpen} title="Delete client">
        <Modal.Body>
          <Stack gap="medium">
            <Text>Are you sure you want to delete
              {' '}<strong>{orgName}</strong>{' '}
              from your clients?
            </Text>
            <Text>
              Please note: If this client has chased this month, you will be billed for the use
              of this licence. If you have any questions, please email{' '}
              <TextLink
                as="a"
                href="mailto:support@chaserhq.com"
                rel="noopener noreferrer"
                monochrome
              >
                support@chaserhq.com
              </TextLink>
            </Text>
          </Stack>
        </Modal.Body>
        <Modal.Footer>
          <ButtonGroup>
            <Button intent="danger" onClick={removeOrg}>
              Yes, delete
            </Button>
            <Button appearance="secondary" onClick={() => setModalOpen(false)}>
              Cancel
          </Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal>
      <Tooltip
        disable={!isDisabled}
        content={isDisabled && "You don't have access to this organisation"}
        position="left"
      >
        <Popover
          onToggle={setDropdownOpen}
          position={Position.BOTTOM_RIGHT}
          shown={dropdownOpen}
          target={<Button data-testid={`action-btn-${shortCode}`} size="narrow" appearance="minimal" active={dropdownOpen} icon="options" />}
        >
          <Card>
            <Menu>
              <Menu.Item
                id="goto-client-btn"
                data-testid="goto-client-btn"
                disabled={isDisabled}
                as="a"
                target="_blank"
                href={!isDisabled && `${config.webAppUrl}/o/${shortCode}`}
              >
                Go to client
              </Menu.Item>
              <Menu.Item
                disabled={isDisabled || isConnected}
                as="a"
                target="_blank"
                href={(!isDisabled && !isConnected) && `${config.webAppUrl}/o/${shortCode}`}
              >
                Reconnect
                {' '}
                <OpenNew fill={isConnected || isDisabled ? '#BABCC0' : ''} />
              </Menu.Item>
              <Menu.Item disabled={false}>
                <Text onClick={() => setModalOpen(true)} baseline={false} color="Red">Delete client</Text>
              </Menu.Item>
            </Menu>
          </Card>
        </Popover>
      </Tooltip>
    </>
  );
};

export default Actions;

Actions.propTypes = {
  shortCode: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isConnected: PropTypes.bool.isRequired,
};
